function CloneStatus({ clone }) {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'text-green-400 bg-green-500/20';
      case 'training':
        return 'text-yellow-400 bg-yellow-500/20';
      case 'failed':
        return 'text-red-400 bg-red-500/20';
      default:
        return 'text-gray-400 bg-gray-500/20';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'completed':
        return 'Ready';
      case 'training':
        return 'Training';
      case 'failed':
        return 'Failed';
      default:
        return 'Pending';
    }
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold">{clone.name}</h3>
        <span className={`px-3 py-1 rounded-full text-sm ${getStatusColor(clone.training_status)}`}>
          {getStatusText(clone.training_status)}
        </span>
      </div>

      {clone.description && (
        <p className="text-gray-400 text-sm mb-4">{clone.description}</p>
      )}

      <div className="space-y-3">
        {/* Sample info */}
        <div className="flex justify-between text-sm">
          <span className="text-gray-400">Samples</span>
          <span>{clone.sample_count} files</span>
        </div>

        <div className="flex justify-between text-sm">
          <span className="text-gray-400">Total Duration</span>
          <span>{clone.total_sample_duration.toFixed(1)}s</span>
        </div>

        {/* Progress bar for training */}
        {clone.training_status === 'training' && (
          <div className="mt-4">
            <div className="flex justify-between text-sm mb-1">
              <span className="text-gray-400">Training Progress</span>
              <span>{Math.round(clone.training_progress * 100)}%</span>
            </div>
            <div className="w-full bg-gray-700 rounded-full h-2">
              <div
                className="bg-purple-500 h-2 rounded-full transition-all"
                style={{ width: `${clone.training_progress * 100}%` }}
              />
            </div>
          </div>
        )}

        {/* Quality score */}
        {clone.quality_score && (
          <div className="flex justify-between text-sm">
            <span className="text-gray-400">Quality Score</span>
            <span className={clone.quality_score > 0.7 ? 'text-green-400' : 'text-yellow-400'}>
              {Math.round(clone.quality_score * 100)}%
            </span>
          </div>
        )}

        {/* Usage */}
        <div className="flex justify-between text-sm">
          <span className="text-gray-400">Usage Count</span>
          <span>{clone.usage_count} times</span>
        </div>
      </div>
    </div>
  );
}

export default CloneStatus;
